// Input sanitization function to prevent XSS and SQL injection
export const sanitizeInput = (input: string): string => {
  if (!input) return '';
  // Remove any HTML tags
  const withoutHtml = input.replace(/<[^>]*>/g, '');
  // Remove any SQL injection patterns
  const withoutSql = withoutHtml.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, char => {
    switch (char) {
      case '\0':
        return '\\0';
      case '\x08':
        return '\\b';
      case '\x09':
        return '\\t';
      case '\x1a':
        return '\\z';
      case '\n':
        return '\\n';
      case '\r':
        return '\\r';
      case '"':
      case "'":
      case '\\':
      case '%':
        return '\\' + char;
      default:
        return char;
    }
  });
  return withoutSql.trim();
};

// Email validation
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

// Password validation
export const validatePassword = (password: string): boolean => {
  // At least 6 characters, containing only letters, numbers, and basic special characters
  const passwordRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{6,}$/;
  return passwordRegex.test(password);
};

// Username validation
export const validateUsername = (username: string): boolean => {
  // 3-20 characters, letters, numbers, underscores, and hyphens only
  const usernameRegex = /^[a-zA-Z0-9_-]{3,20}$/;
  return usernameRegex.test(username);
};

// Phone number validation (Singapore format)
export const validatePhone = (phone: string): boolean => {
  // Singapore phone numbers: 8 digits starting with 8 or 9
  const phoneRegex = /^[89]\d{7}$/;
  return phoneRegex.test(phone.replace(/\D/g, '')); // Remove non-digits before validation
};

// User group validation
export const validateUserGroup = (userGroup: string): boolean => {
  const validGroups = [
    'OS Team',
    'Show Support',
    'Show Management (Bay)',
    'Show Management (Padang)',
    'Artiste Management',
    'Log & Finance',
    'Ops. Safety and Contingencies'
  ];
  return validGroups.includes(userGroup);
}; 